module.exports = __webpack_public_path__ + "static/media/Tania2.60c170e0.jpeg";